/* eslint-disable */

/** unique or primary key constraints on table "argo.material_note_comment" */
export enum ArgoMaterialNoteCommentConstraint {
  /** unique or primary key constraint on columns "material_note_comment_id" */
  MaterialNoteCommentPkey = 'material_note_comment_pkey'
}

/** select columns of table "argo.material_note_comment" */
export enum ArgoMaterialNoteCommentSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  MaterialNoteCommentId = 'material_note_comment_id',
  /** column name */
  MaterialNoteId = 'material_note_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NoteStatus = 'note_status',
  /** column name */
  PreviousCommentContent = 'previous_comment_content',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.material_note_comment" */
export enum ArgoMaterialNoteCommentUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  MaterialNoteCommentId = 'material_note_comment_id',
  /** column name */
  MaterialNoteId = 'material_note_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NoteStatus = 'note_status',
  /** column name */
  PreviousCommentContent = 'previous_comment_content',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

